<template>
    <div class="body">
        <div class="title">
                <span class="logo">七鸥鸥</span>
                <span class="titleSize">商家管理系统</span>
                <ul class="buttonList">
                    <li  v-for="(item,index) in option" :key="index"  @mouseover="buttonList(index)" @click="pitchOn(item.resourceId)"  >{{item.name}}</li>
                </ul>
        </div>
        <el-carousel :interval="4000" direction="vertical" :autoplay="true" class="option"  height="950px"  ref="carousel">
            <el-carousel-item class="carouse" v-for="(item,index) in option" :key="index"  :style = "{background:'url('+item.imgUrl+') center center no-repeat'}" >
            </el-carousel-item>
        </el-carousel>
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const {mapState, mapGetters, mapMutations, mapActions } = createNamespacedHelpers('user')
export default {
    data(){
        return{
            option:[]
        }
    },
    mounted(){
       this.options()
    },
    methods:{
        options(){
            this.joker.user.option().then(res=>{
                console.log(res)
                this.option = res.content
            }).catch(res=>{

            })
        },
        buttonList(id){
            this.$refs.carousel.activeIndex = id
        },
        pitchOn(id){
            localStorage.setItem('optionId',id)
            this.$router.replace('/Home')
        }
    }
}
</script>

<style scoped>

.el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 200px;
    margin: 0;
  }
  
  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }
  
  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }

  .option{
      z-index:1;
      width: 100%;
      height: 100%;
      
  }

  .body{
      position:relative; 
      width: 100%;
      height: 100%;
      
  }

  .carouse{
      width: 100%;
      height: 100%;
      background-size: 100% 100%;
      position: fixed;
      filter: brightness(90%);
  }

  .title{
    -webkit-box-flex: 1;
    -moz-box-flex:1;
    text-align: left;
    font-size:14px;
    line-height:22px;
    width: 100%;
    height: 80px;
    /* margin-top:0.2%; */
    background:rgba(37,37,37,0.5);
    position:absolute; 
    z-index:2;
  }

  .image{
        width: auto;  
        height: auto;  
        max-width: 100%;  
        max-height: 100%;
  }

  .logo{
      line-height: 80px;
      font-size: 45px;
      opacity: 1;
      color:#FFFFFF;
      font-family: '华文行楷';
      margin-left: 6%;
  }

 .titleSize{
     line-height: 80px;
     opacity: 1;
     font-size: 28px;
     color:#FFFFFF;
 }

 .medium{
     font-size: 50px;
     font-weight: 700;
     font-family: '行楷';
     opacity: 0.7;
 }

 .name{
   position:absolute; 
   color: #FFFFFF;
   margin-left: 46%;
   margin-top: 40%;
 }

 ul{display: block;}
 ul li{
     /* background-color: red; */
     width: 5%;
     margin-top: 2%;
     text-align: center;
     margin-left: 80%;
 }
 ul li:hover{
     transform:scale(1.5,1.5);
     /* box-shadow: 0 0 5px #ffffff; */
     cursor: pointer;
 }

 .buttonList{
     color: #FFFFFF;
     font-size: 32px;
     margin-top: 15%;
 }


</style>




// WEBPACK FOOTER //
// src/components/Home/option.vue